/**
 * Owner: Masa Bayu
 * File: brand-assets.ts
 * Date:Time: 2026-09-20 10:14
 * Description: QXRead / QXCircle brand URLs — Owner qxread.png mark.
 */

import qxcircleLogo from '../assets/brand/qxcircle-logo.png';
import qxcircleMark from '../assets/brand/qxcircle-mark.png';
import qxcircleWordmark from '../assets/brand/qxcircle-wordmark.png';
import qxreadLogo from '../assets/brand/qxread.png';

export const QX_BRAND = Object.freeze({
  logo: qxreadLogo,
  mark: qxreadLogo,
  wordmark: qxreadLogo,
  alt: 'QXRead',
  circleLogo: qxcircleLogo,
  circleMark: qxcircleMark,
  circleWordmark: qxcircleWordmark,
  circleAlt: 'QXCircle',
});

/** Owner ruling §396: fixed brand tagline beside every logo lockup (not localized). */
export const QX_TAGLINE = Object.freeze({
  top: 'YOUR WORLD OF EBOOKS',
  bottom: 'Create. Read. Inspire.',
});
